import { render } from "./PatientsDatatableFormWaitingClient.vue?vue&type=template&id=82ec2b94"
import script from "./PatientsDatatableFormWaitingClient.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableFormWaitingClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__